import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Button, SxProps, Theme } from '@mui/material';

const STRINGS = appStrings.modules.solutionSessions.questions;

type SkipChatButtonProps = Readonly<{
  id?: string;
  disabled?: boolean;
  onSkip: () => void;
}>;

export const SkipChatButton = ({
  id = 'chat-question-skip-button',
  disabled,
  onSkip,
}: SkipChatButtonProps) => {
  return (
    <Button
      id={id}
      hierarchy="Tertiary color"
      size="sm"
      onClick={onSkip}
      disabled={disabled}
      sx={buttonSx}
    >
      {STRINGS.skip}
    </Button>
  );
};

const buttonSx: SxProps<Theme> = ({ typography }) => ({
  ...typography['text-sm-semibold'],
});
